// Module
var code = "<polls-results></polls-results>";
// Exports
module.exports = code;